import React from 'react'
import { SortableElement } from 'react-sortable-hoc'
import { PrioritiesTableRow } from './PrioritiesTableRow'
import { connect } from 'react-redux'

const SortableItem = SortableElement(PrioritiesTableRow)

const PrioritiesTableBodyComponent = ({ list, dispatch }) => (
  <tbody>
    {list.map((mediaType, index) => (
      <SortableItem
        key={`item-${index}`}
        index={index}
        mediaType={mediaType}
        dispatch={dispatch}
      />
    ))}
  </tbody>
)

export const PrioritiesTableBody = connect()(PrioritiesTableBodyComponent)
